import type { SVGProps } from "react";

export default function ShareNodesIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7.49968 9.99982C7.49968 11.1504 6.56694 12.0832 5.41635 12.0832C4.26576 12.0832 3.33302 11.1504 3.33302 9.99982C3.33302 8.84924 4.26576 7.91649 5.41635 7.91649C6.56694 7.91649 7.49968 8.84924 7.49968 9.99982Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M11.6665 5.4164L7.49983 8.33307"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M11.6665 14.5829L7.49983 11.6662"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M15.8331 15.4162C15.8331 16.5668 14.9003 17.4996 13.7498 17.4996C12.5992 17.4996 11.6664 16.5668 11.6664 15.4162C11.6664 14.2657 12.5992 13.3329 13.7498 13.3329C14.9003 13.3329 15.8331 14.2657 15.8331 15.4162Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M15.8331 4.58297C15.8331 5.73356 14.9003 6.6663 13.7498 6.6663C12.5992 6.6663 11.6664 5.73356 11.6664 4.58297C11.6664 3.43238 12.5992 2.49964 13.7498 2.49964C14.9003 2.49964 15.8331 3.43238 15.8331 4.58297Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
